// A STOREFRONT PRIVATE FRAME KEEPS ITS SHARED DEFAULT WHEN ITS ANSWER IS NOT THE FRAME (an error page,
// a 404, a redirect to sign-in). The cached page already draws what a visitor with no standing sees, as
// plain links and forms that work on their own. Turbo's default writes "Content missing" over it instead:
// English on an Arabic page, the buy box gone, and everything below it shifted up (QUAL-04).
export function keepPrivateFrameDefaults() {
  document.addEventListener("turbo:frame-missing", (event) => {
    if (event.target.hasAttribute("data-storefront-private-frame")) event.preventDefault()
  })
}
